import BarcodeScanner from "./BarcodeScanner.js";
export { default as BarcodeStringFormat } from "./BarcodeStringFormat.js";
export { BarcodeFormat } from "@zxing/library";
export default BarcodeScanner;
